var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import makeStyles from '@mui/styles/makeStyles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from '@mui/material/Grid';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import { ToggleButton } from '../';
import Item from './Item';
import Paper from './Paper';

export var MAX_COLUMNS = 12;
export var COLUMNS = [12, 12, 6, 4, 3, 3, 2, 2, 2, 2, 2, 2, 1];

var useStyles = makeStyles(function () {
  return {
    collapseContainer: {
      width: '100%'
    }
  };
});

var CollapseButtons = function CollapseButtons(props) {
  var _props$items = props.items,
      items = _props$items === undefined ? [] : _props$items,
      _props$action = props.action,
      action = _props$action === undefined ? function () {} : _props$action,
      _props$nbColumns = props.nbColumns,
      nbColumns = _props$nbColumns === undefined ? 3 : _props$nbColumns,
      _props$testId = props.testId,
      testId = _props$testId === undefined ? 'collapseButton' : _props$testId,
      isSecondLevelClikable = props.isSecondLevelClikable,
      _props$gridButtonsPro = props.gridButtonsProps,
      gridButtonsProps = _props$gridButtonsPro === undefined ? {} : _props$gridButtonsPro,
      _props$breakpoint = props.breakpoint,
      breakpoint = _props$breakpoint === undefined ? function (theme) {
    return theme.breakpoints.down('md');
  } : _props$breakpoint,
      justify = props.justify,
      _props$textTransform = props.textTransform,
      textTransform = _props$textTransform === undefined ? 'none' : _props$textTransform,
      _props$labelAccessor = props.labelAccessor,
      labelAccessor = _props$labelAccessor === undefined ? R.prop('label') : _props$labelAccessor;


  var classes = useStyles();
  var isMobileView = useMediaQuery(breakpoint);

  var _useState = useState(),
      toggleId = _useState[0],
      setIsOpen = _useState[1];

  useEffect(function () {
    var _setIsOpen;

    var id = props.selectedItemId;
    if (props.selectedItemId) setIsOpen((_setIsOpen = {}, _setIsOpen[id] = true, _setIsOpen));
  }, [props.selectedItemId]);

  var getValues = function getValues(parentId) {
    return R.map(function (item) {
      return React.createElement(Item, {
        key: R.prop('id')(item),
        testId: testId + '_' + parentId + '_value_' + R.prop('id')(item),
        parentId: parentId,
        item: item,
        action: action,
        isSecondLevelClikable: isSecondLevelClikable,
        labelAccessor: labelAccessor
      });
    });
  };

  return React.createElement(
    Grid,
    { container: true, spacing: 2, 'data-testid': testId, justifyContent: justify },
    R.map(function (_ref) {
      var id = _ref.id,
          label = _ref.label,
          _ref$values = _ref.values,
          values = _ref$values === undefined ? [] : _ref$values;
      return React.createElement(
        Grid,
        _extends({ item: true, xs: 12, sm: 12, md: R.nth(nbColumns)(COLUMNS) }, gridButtonsProps, { key: id }),
        React.createElement(
          Typography,
          { variant: 'h3' },
          React.createElement(ToggleButton, {
            textTransform: textTransform,
            label: label,
            tabindex: R.isNil(toggleId) || R.prop(id)(toggleId) || R.compose(R.not, R.head, R.values)(toggleId) ? 0 : -1,
            isOpen: R.prop(id)(toggleId),
            toggle: function toggle() {
              var _setIsOpen2;

              return setIsOpen((_setIsOpen2 = {}, _setIsOpen2[id] = !R.prop(id)(toggleId), _setIsOpen2));
            },
            testId: testId + '_' + id,
            id: id
          }),
          isMobileView && React.createElement(
            Collapse,
            {
              'in': R.prop(id)(toggleId),
              timeout: 'auto',
              unmountOnExit: true,
              className: classes.collapseContainer
            },
            React.createElement(
              Paper,
              { elevation: 10, isMobileView: isMobileView },
              getValues(id)(values)
            )
          )
        )
      );
    })(items),
    !isMobileView && R.map(function (_ref2) {
      var id = _ref2.id,
          _ref2$values = _ref2.values,
          values = _ref2$values === undefined ? [] : _ref2$values;
      return React.createElement(
        Collapse,
        {
          'in': R.prop(id)(toggleId),
          timeout: 'auto',
          unmountOnExit: true,
          key: id,
          className: classes.collapseContainer
        },
        React.createElement(
          Paper,
          { elevation: 10 },
          getValues(id)(values)
        )
      );
    })(items)
  );
};

CollapseButtons.propTypes = process.env.NODE_ENV !== "production" ? {
  testId: PropTypes.string,
  selectedItemId: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    svgPath: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      subtopics: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
      }), PropTypes.string]))
    }))
  })),
  action: PropTypes.func,
  nbColumns: PropTypes.number,
  isSecondLevelClikable: PropTypes.bool,
  breakpoint: PropTypes.func,
  gridButtonsProps: PropTypes.object,
  justify: PropTypes.string,
  textTransform: PropTypes.string,
  labelAccessor: PropTypes.func
} : {};

export default CollapseButtons;